export const ADD_PAYMENT = "/payments/:id/add_payment/";
